import { RequestCustomerStatus } from 'cpfr-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { NameChangeStatusSelector } from './NameChangeStatusSelector';
import { fetchNameChangeStatus } from './NameChangeStatusSlice';

export function useNameChangeStatus(): AbstractDataState<RequestCustomerStatus, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchNameChangeStatus, NameChangeStatusSelector);
}
